import * as React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
// import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';
import Visibility from '@material-ui/icons/Visibility';
import Snackbar from '@material-ui/core/Snackbar';
import { LinearProgress, Tooltip, Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { ModalImage } from 'src/component/shared/layout/components/ModalImage/ModalImage';
import * as Moment from 'moment';
import { ConfirmModal } from 'src/component/shared/confirm-modal';
import { ConfirmModalAction } from 'src/component/shared/confirm-modal/ConfirmModalAction';
import { ConfirmModalActions } from 'src/component/shared/confirm-modal/ConfirmModalActions';

import './PublisherAnalytical.scss';
import gql from 'graphql-tag';
import { Query, ApolloConsumer } from 'react-apollo';
import { QUERY_FILTER_PUBLISHER, QueryFilter } from '../../shared';
import {
  MoneyFullBRL,
  NumberLessBRL,
  MoneyBRL,
  NumberConvert,
  CurrentDate,
  SomeDaysAgo
} from '../../../services';
import Rest from 'src/services/Rest';
import { client as clientGql } from "src";
import LoadTableInfinity from 'src/component/load-table/LoadTableInfinity';
import ExportInProgress from 'src/component/export-in-progress/ExportInProgress';

// tslint:disable-next-line:no-empty-interface
export interface ITableAnalyticalPros {
}

export interface ITableAnalytical {
  count: number,
  dialogOpen: boolean,
  endDate: any,
  initialDate: any,
  item: {
    count: undefined,
    publisherAnalysisSubTotalsData: any,
  },
  limit: number,
  load: boolean,
  modalImage: {
    img: any,
    open: boolean,
  },
  offset: number,
  openConfirm: boolean,
  openSnack: boolean,
  page: number,
  processando: boolean,
  rows?: any,
  snackMessage: string
}

// const QUERY_ANALYSIS_DATA_PUBLISHER = gql`
// query publisherAnalysisData($customFilter:  PublisherCustomFilter) {
//   publisherAnalysisData(publisherCustomFilter: $customFilter) {
//     sku
//     price
//     description
//     revenue
//     volume
//     price
//     qty_coupon
//     image
//   },
//   publisherCountAnalysis(publisherCustomFilter: $customFilter),
//   publisherAnalysisSubTotalsData(publisherCustomFilter: $customFilter) {
//     revenue
//     price
//     qty_coupon
//     volume
//   }
// }
// `;

const QUERY_FILE_REPORT = gql`
query publisherAnalysisData($customFilter:  PublisherCustomFilter) {
  getFileReport(publisherCustomFilter: $customFilter)
}
`;

const QUERY_DETAILED_FILE_REPORT = gql`
query publisherAnalysisData($customFilter:  PublisherCustomFilter) {
  getDetailedFileReport(publisherCustomFilter: $customFilter)
}
`;

export class TableAnalytical
  extends React.Component<ITableAnalyticalPros, ITableAnalytical> {

  private lockFileRequest: boolean = false;

  constructor(props: ITableAnalyticalPros) {
    super(props);

    const finalDate = CurrentDate();
    const initDate = SomeDaysAgo(32);

    this.state = {
      count: 100,
      dialogOpen: false,
      endDate: finalDate,
      initialDate: initDate,
      item: {
        count: undefined,
        publisherAnalysisSubTotalsData: [],
      },
      limit: 30,
      load: false,
      modalImage: {
        img: '',
        open: false,
      },
      offset: 0,
      openConfirm: false,
      openSnack: false,
      page: 0,
      processando: false,
      rows: [],
      snackMessage: ""
    }

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSnackClose = this.handleSnackClose.bind(this);
    this.handleCloseConfirm = this.handleCloseConfirm.bind(this);
    this.search = this.search.bind(this);
    this.countAndSubTotal = this.countAndSubTotal.bind(this);
  }

  public componentWillMount() {
    this.search(0);
    this.countAndSubTotal(0)
  }

  public render() {
    const jsonFilter = {
      "customFilter": {
        "endDate": this.state.endDate,
        "initialDate": this.state.initialDate,
        "limit": this.state.limit,
        "offset": this.state.offset,
      }
    };

    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.openSnack}
          onClose={this.handleSnackClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.snackMessage}</span>}
        />
        <ConfirmModal.Root open={this.state.openConfirm} onClose={this.handleCloseConfirm}  disableBackdropClick={true} disableEscapeKeyDown={true} >
          <ConfirmModal.Title label='Aviso' />  
          <ConfirmModal.Content>
            <Typography>{'O relatório possui um período superior a 35 dias e será liberado em até 24 horas.'}</Typography>
          </ConfirmModal.Content>   
          <ConfirmModalActions>
            <ConfirmModalAction onClick={this.handleCloseConfirm} label={'OK'} color='primary' variant="contained"/>
          </ConfirmModalActions> 
        </ConfirmModal.Root>
        <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}>
          {({ loading: loadingC, error: errorC, data: cache, client: clientC, refetch: refetchC }) => {
            // <Query query={QUERY_ANALYSIS_DATA_PUBLISHER}
            // variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, [])}
            // partialRefetch={true}>
            // {({ loading, error, data, client, refetch}) => {
            this.handleClickSearch(loadingC);
            return (
              <Paper className="analytical-panel">
                <Grid container={true} className="analytical-header">
                  <Grid item={true} xs={8}>
                    <form onSubmit={this.requestByDate.bind(this, refetchC, clientC)}>
                      <div className="analytical-date">
                        <TextField
                          defaultValue={this.state.initialDate}
                          id="initialDate"
                          label="Data inicial"
                          type="date"
                          required={true}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(event) => this.handleDateChanges(event, 'initialDate')}
                        />
                      </div>
                      <TextField
                        defaultValue={this.state.endDate}
                        id="endDate"
                        label="Data final"
                        type="date"
                        required={true}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(event) => this.handleDateChanges(event, 'endDate')}
                      />
                      <IconButton type="submit" color="primary" >
                        <Tooltip title="Pesquisar">
                          <SendIcon />
                        </ Tooltip>
                      </IconButton>
                    </form>
                  </Grid>
                  <Grid item={true} xs={2}>
                    <Typography variant="body1" className="qtdDistinctPrd">
                      {this.state.item && this.state.item.count ? this.state.item.count : 0} Livros Diferentes
                    </Typography>
                  </Grid>
                  <Grid item={true} xs={2}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <ExportInProgress
                        tipos={['PUBLISHER_ANALYSIS_DATA_DETALHADO', 'PUBLISHER_ANALYSIS_DATA_SIMPLES']}
                        visible={this.state.processando}
                        handleState={(valor) => this.setState({ processando: valor })} />
                      {!this.state.processando &&
                        <ApolloConsumer>
                          {clientF => (
                            <div>
                              <IconButton
                                color="primary"
                                className="download-button"
                                onClick={this.handleDialogOpen}
                              >
                                <Tooltip title="Exportar">
                                  <GetAppIcon />
                                </ Tooltip>
                              </IconButton>

                              <Dialog
                                open={this.state.dialogOpen}
                                onClose={this.handleDialogClose}
                                aria-labelledby="economic-group-dialog-title"
                                aria-describedby="alereconomic-group-dialog-description"
                                className="filter-dialog"
                                disableBackdropClick={false}
                                disableEscapeKeyDown={false}
                              >
                                <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                                  {"Exportação do Relatório Analítico"}
                                </DialogTitle>
                                <DialogActions>
                                  <Button onClick={this.handleDialogClose} color="secondary">
                                    Cancelar
                                  </Button>
                                  <Button onClick={this.requestGroupedFile.bind(this, clientF, jsonFilter)} color="primary" autoFocus={true}>
                                    Simples
                                  </Button>
                                  <Button onClick={this.requestDetailedFile.bind(this, clientF, jsonFilter)} color="primary" autoFocus={true}>
                                    Detalhado
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </div>
                          )}
                        </ApolloConsumer>
                      }
                    </div>
                  </Grid>
                </Grid>
                {this.informationGridToRend(errorC)}
              </Paper>
            );
            //   }}
            // </Query>
          }}
        </Query>
        <ModalImage
          img={this.state.modalImage.img}
          open={this.state.modalImage.open}
          onClose={() => this.handleModalImage('')}
        />
      </div>
    );
  }



  public requestGroupedFile(client: any, filter: any) {
    this.requestFile(client, filter, QUERY_FILE_REPORT);
  }

  public requestDetailedFile(client: any, filter: any) {
    this.requestFile(client, filter, QUERY_DETAILED_FILE_REPORT);
  }

  public handleCloseConfirm() {
    this.setState({ openConfirm: false });
  }

  public requestFile(client: any, filter: any, gqlQuery:any) {
    this.handleDialogClose();
    if (this.lockFileRequest) {
      return;
    }

    const deepFilter = QueryFilter.getFilterPublisher(clientGql, filter, []);

    delete deepFilter.customFilter.limit;
    delete deepFilter.customFilter.offset;

    const diference = Moment(deepFilter.customFilter.endDate,'YYYY-MM-DD')
    .diff(Moment(deepFilter.customFilter.initialDate, 'YYYY-MM-DD'), 'days');
    this.lockFileRequest = true;
    if ( diference > 35) {
      this.setState({ openConfirm: true });
    } else {
      this.setState({
        openSnack: true,
        processando: true,
        snackMessage: "O relatório está sendo preparado para download",
      });
    }

    client.query({
      fetchPolicy: 'network-only',
      query: gqlQuery,
      variables: deepFilter
    }).then(() => {
      this.lockFileRequest = false;
    });
  }

  public handleClickSearch(loading: any) {
    if (this.state.load) {
      return
    }
    if (loading) {
      this.setState({ page: 0, offset: 0, rows: [] })
      this.search(0)
      this.countAndSubTotal(0)
    }
  }

  public handleSnackClose(ev: any) {
    this.setState({
      openSnack: false,
    });
  }

  public requestByDate(refetch: any, clientC: any, ev: any) {
    ev.preventDefault();

    this.setState({
      endDate: ev.target.endDate.value,
      initialDate: ev.target.initialDate.value,
    });

    QueryFilter.updateMutationPublisher();
  }

  public search(offset: any) {
    this.setState({ load: true })
    const jsonFilter = {
      "customFilter": {
        "endDate": this.state.endDate,
        "initialDate": this.state.initialDate,
        "limit": this.state.limit,
        "offset": offset,
      }
    };

    const params = QueryFilter.getFilterPublisher(clientGql, jsonFilter, [])

    Rest.POST('publisherAnalysisData', params)
      .then((result): any => result)
      .then(response => {
        const list = this.state.rows.concat(response.data)
        this.setState({ rows: list, load: false })
      })
      .catch(err => {
        console.log(err)
        this.setState({ load: false })
      })
  }

  public countAndSubTotal(offset: any) {
    this.setState({ load: true })
    const jsonFilter = {
      "customFilter": {
        "endDate": this.state.endDate,
        "initialDate": this.state.initialDate,
        "limit": this.state.limit,
        "offset": offset,
      }
    };

    const params = QueryFilter.getFilterPublisher(clientGql, jsonFilter, [])

    Rest.POST('publisherAnalysisSubTotalsData', params)
      .then((result): any => result)
      .then(response => {
        this.setState({ load: false, item: response.data })
      })
      .catch(err => {
        console.log(err)
        this.setState({ load: false })
      })
  }

  /**
   * Método utilizado para renderizar as informações do card
   * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
   */
  private informationGridToRend(error: any) {
    return (
      <div>
        <div className="analytical-table">

          {this.state.load ? <LinearProgress /> : <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell>Faturamento</TableCell>
                <TableCell>Share</TableCell>
                <TableCell>Preço Médio</TableCell>
                <TableCell>Volume</TableCell>
                <TableCell>Qtde Cupons</TableCell>
              </TableRow>
            </TableHead>

            {error ?

              <TableBody>
                <TableRow>
                  <TableCell colSpan={8} >Falha ao aplicar filtro, tente novamente.</TableCell>
                </TableRow>
              </TableBody> :

              <TableBody>
                <TableRow>
                  <TableCell className="analytical-total padding-left" component="th" scope="row">
                    TOTAL
                  </TableCell>
                  <TableCell />
                  <TableCell />
                  <TableCell />
                  <TableCell className="analytical-total"> {this.state.item && this.state.item.publisherAnalysisSubTotalsData.length > 0 ? MoneyFullBRL(this.state.item.publisherAnalysisSubTotalsData[0].revenue) : 0} </TableCell>
                  <TableCell className="analytical-total">100%</TableCell>
                  <TableCell className="analytical-total"> {this.state.item && this.state.item.publisherAnalysisSubTotalsData.length > 0 ? MoneyFullBRL(this.state.item.publisherAnalysisSubTotalsData[0].price) : 0} </TableCell>
                  <TableCell className="analytical-total"> {this.state.item && this.state.item.publisherAnalysisSubTotalsData.length > 0 ? NumberLessBRL(this.state.item.publisherAnalysisSubTotalsData[0].volume) : 0} </TableCell>
                  <TableCell className="analytical-total"> {this.state.item && this.state.item.publisherAnalysisSubTotalsData.length > 0 ? this.state.item.publisherAnalysisSubTotalsData[0].qty_coupon : 0} </TableCell>
                </TableRow>
                {
                  this.state.rows.length > 0 ? this.state.rows.map((row: any, key: number) => {
                    return (
                      <TableRow key={key}>
                        <TableCell className="padding-left">{1 + key}</TableCell>
                        <TableCell>
                          {!!row.image && <IconButton
                            onClick={() => this.handleModalImage(row.image)}
                            style={{ padding: '0px' }}
                          >
                            <Visibility />
                          </IconButton>}
                        </TableCell>
                        <TableCell component="th" scope="row">{row.sku}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell>{MoneyBRL(row.revenue)}</TableCell>
                        <TableCell>
                          {
                            this.state.item && this.state.item.publisherAnalysisSubTotalsData.length > 0 && row && row.revenue ?
                              (NumberConvert(row.revenue) * 100 / NumberConvert(this.state.item.publisherAnalysisSubTotalsData[0].revenue)).toFixed(1) + '%' :
                              0 + '%'
                          }
                        </TableCell>
                        <TableCell className="analytical-cell">{MoneyBRL(row.price)}</TableCell>
                        <TableCell>{NumberLessBRL(row.volume)}</TableCell>
                        <TableCell>{row.qty_coupon}</TableCell>
                      </TableRow>
                    );
                  }) : <div />
                }
              </TableBody>
            }
          </Table>}
        </div>
        {
          this.state.load ? (
            <div className="loading-margin" />
          ) : (
            <LoadTableInfinity
              fetchLoad={this.handleChangePage}
              last={this.state.rows.length < 1 ||
                this.state.rows.length < this.state.offset ||
                this.state.rows.length < this.state.limit} />
          )
        }
      </div>
    );
  }

  private handleChangePage() {
    const params = this.state.page + 1;
    const newOffset = params * this.state.limit;
    this.setState({
      offset: newOffset,
      page: params,
    })
    this.search(newOffset)
  }

  private handleModalImage = (img: any) => {
    this.setState({ modalImage: { img, open: !this.state.modalImage.open } })
  }

  private handleDialogOpen = () => {
    // tslint:disable-next-line:no-string-literal
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };

  private handleDateChanges(event: React.ChangeEvent<HTMLInputElement>, field: string) {
    // Esta função lida com mudanças em um campo de entrada do tipo 'date'.
    // A ideia é identificar se a mudança foi causada pela seleção de uma data (dia) 
    // ou pela transição de mês usando as setas para cima/baixo no datepicker.
    // Se for uma transição de mês, a função apenas atualiza o estado sem fazer buscas adicionais.
    // Se for uma seleção de dia, chama as duas funções (`search` e `countAndSubTotal`) para atualizar resultados do grid.
    // O comportamento é determinado comparando a parte de mês e dia das datas antiga e nova.
    
    const newValue = event.target.value;
    const newState: any = {};
    newState[field] = newValue;

    const oldValue = this.state[field];

    this.setState(newState, () => {
      const oldDate = oldValue;
      const newDate = newValue;

      const oldMonthStr = oldDate.substring(5, 7);
      const newMonthStr = newDate.substring(5, 7);
      const oldDayStr = oldDate.substring(8, 10);
      const newDayStr = newDate.substring(8, 10);

      const oldMonth = parseInt(oldMonthStr, 10);
      const newMonth = parseInt(newMonthStr, 10);
      const oldDay = parseInt(oldDayStr, 10);
      const newDay = parseInt(newDayStr, 10);

      const monthDifference = newMonth - oldMonth;
      const dayDifference = newDay - oldDay;

      let isMonthTransition = false;

      if (dayDifference === 0) {
        if (monthDifference > 0) {
          isMonthTransition = true;
        } else if (monthDifference < 0) {
          isMonthTransition = true;
        }
      }

      if (!isMonthTransition) {
        this.search(0);
        this.countAndSubTotal(0);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/component/publisher/analytical/TableAnalytical.tsx